<template>
    <div class="d-flex info-block">
        <iframe class="me-3 mb-3" width="200" height="100" src="https://www.youtube.com/embed/wpmHZspl4EM"></iframe>
        <div class="flex-grow-1">
            <h4>
                Tivo introduces a IELTS Coaching, TOEFL Coaching, GRE Coaching.
            </h4>
            <a href="javascript:void(0)" data-bs-original-title="" title="">kohoeducation.info/</a>
            <p>
                Tivo introduces a IELTS Coaching, TOEFL Coaching, GRE Coaching, GMAT
                Coaching, SAT Coaching in Surat.
            </p>
            <div class="star-ratings">
                <ul class="search-info">
                    <li>2.5 stars</li>
                    <li>590 votes</li>
                    <li>Music</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="info-block">
        <nav aria-label="...">
            <ul class="pagination pagination-primary">
                <li class="page-item disabled">
                    <a class="page-link" href="javascript:void(0)" tabindex="-1">Previous</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="javascript:void(0)">1</a>
                </li>
                <li class="page-item active">
                    <a class="page-link" href="javascript:void(0)">2 <span class="sr-only">(current)</span></a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="javascript:void(0)">3</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="javascript:void(0)">Next</a>
                </li>
            </ul>
        </nav>
    </div>
</template>